import { Serializer as JSONAPISerializer } from 'jsonapi-serializer';

// The API rejects unknown attributes, so only the writable ones go out.
// `id` is sent when present, which a PATCH requires.
export const ApiClientSerializer = new JSONAPISerializer('api-clients', {
  keyForAttribute: 'camelCase',
  attributes: [
    'name',
    'applicationType',
    'tokenEndpointAuthMethod',
    'redirectUris',
    'scopes',
    'clientUri',
  ],
});
